import { useEffect, useRef, useState, useCallback } from "react";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { roundedStyleSelect, styleSelect } from "../../constants/customStyles";
import { getAllCustomer } from "../../actions/CustomerActions";
import { getAllVehicle } from "../../actions/VehicleActions";
import { getAllInsuranceCompany } from "../../actions/InsuranceCompanyActions";
import Toast from "../../components/Toast";
import {
  getEstimateByInvestigationId,
  saveEstimate,
} from "../../actions/EstimateActions";
import { useNavigate, useParams } from "react-router-dom";
import { getInvestigationById } from "../../actions/InvestigationActions";
import { getAllProductCategory } from "../../actions/ProductCategoryActions";
import {
  getAllProduct,
  getProductByCategoryId,
} from "../../actions/ProductActions";
import {
  getAllAccidentType,
  saveAccidentType,
} from "../../actions/AccidentTypeActions";
import CreatableSelect from "react-select/creatable";
import AddProduct from "../Investigation/addProductModal";
import moment from "moment/moment";
import { ThreeDots } from "react-loader-spinner";
import Mobilemenu from "../../layouts/mobile-menu";
import EditVehicleModal from "../JobCard/modals/edit-vehicle";
import EditCustomerModal from "../JobCard/modals/edit-customer";
import SignatureCanvas from "react-signature-canvas";

function AddEstimate() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const params = useParams();

  const [investigationId, setInvestigationId] = useState(
    params.investigation_id ? params.investigation_id : null,
  );
  const [investigationDetails, setInvestigationDetails] = useState({});
  const [savedEstimateDetails, setSavedEstimateDetails] = useState({});
  const [estimateDate, setEstimateDate] = useState("");
  const [amount, setAmount] = useState("");
  const [repairTime, setRepairTime] = useState("");
  const [milage, setMilage] = useState("");
  const [accidentType, setAccidentType] = useState("");
  const [typeId, setTypeId] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [contractorId, setContractorId] = useState("");
  const [selectedContractor, setSelectedContractor] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [vehicleId, setVehicleId] = useState("");
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [lumpSum, setLumpSum] = useState(0);
  const [lumpSumAmount, setLumpSumAmount] = useState("");
  const [costPer, setCostPer] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [product, setProduct] = useState("");
  const [vehicleGraph, setVehicleGraph] = useState("");
  const [fuelLevel, setFuelLevel] = useState("");

  useEffect(() => {
    if (typeId !== 2) {
      setContractorId("");
    }
  }, [typeId]);

  useEffect(() => {
    dispatch(getInvestigationById(params.investigation_id));
    const fetchInvestigationAndEstimate = async () => {
      await dispatch(getEstimateByInvestigationId(params.investigation_id));
    };
    fetchInvestigationAndEstimate();
  }, [params.investigation_id, dispatch]);

  const investigation = useSelector(
    (state) => state?.investigation?.investigation,
  );
  const estimateSaved = useSelector((state) => state?.estimate?.estimateSaved);
  const user_id = JSON.parse(localStorage.getItem("user"));

  const updateInvestigationDetails = useCallback((details) => {
    setInvestigationDetails(details);
    setEstimateDate(moment(details?.estimate_date).format("YYYY-MM-DD"));
    setAmount(details.total_amount ?? "");
    setMilage(details?.milage ?? "");
    setAccidentType(
      details?.accident_side
        ? { id: details?.accident_side_id, name: details?.accident_side }
        : "",
    );
    setCustomerId(details?.customer_id ?? "");
    setSelectedCustomer(
      details?.customer_id
        ? { id: details?.customer_id, name: details?.customer?.name }
        : "",
    );
    setVehicleId(details?.vehicle_id ?? "");
    setSelectedVehicle(
      details?.vehicle_id
        ? {
            vehicle_id: details?.vehicle_id,
            plate_number: details?.vehicle?.plate_number,
          }
        : "",
    );
    setRepairTime(details?.repair_time ?? "");
    setLumpSum(details?.lump_sum ?? "");
    setTypeId(details?.type_id ?? "");
    setSelectedType(
      details?.type_id === 1
        ? { value: 1, label: "Private" }
        : details?.type_id === 2
          ? { value: 2, label: "Insurance" }
          : details?.type_id === 3
            ? { value: 3, label: "N/A" }
            : "",
    );
    setContractorId(details?.insurance_company_id ?? "");
    setSelectedContractor(
      {
        id: details?.insurance_company_id ?? "",
        name: details?.insurance_company?.name ?? "",
      } ?? "",
    );
    setVehicleGraph(details?.vehicle_graph?.vehicle_graph);
    setFuelLevel(details?.vehicle_graph?.fuel_level);
    setCostPer(details?.cost_percentage);
    setLumpSumAmount(details?.lump_sum_amount);
  }, []);

   useEffect(() => {
        if (estimateSaved && Object.keys(estimateSaved).length > 0) {
            setInvestigationId(estimateSaved.investigation_id);
            loadSignatureFromBase64(estimateSaved?.vehicle_graph?.vehicle_graph);
            updateInvestigationDetails(estimateSaved);
            setCostPer(20);
        } else if (investigation && Object.keys(investigation).length > 0) {
            setInvestigationId(investigation.investigation_id);
            loadSignatureFromBase64(investigation?.vehicle_graph?.vehicle_graph);
            updateInvestigationDetails(investigation);
            setCostPer(20);
        }
    }, [estimateSaved, investigation, params.investigation_id, updateInvestigationDetails]);


  useEffect(() => {
    dispatch(getAllVehicle(null, 999999999, { status: 1 }));
    dispatch(getAllCustomer(null, 999999999, { status: 1 }));
    dispatch(getAllInsuranceCompany(null, 99999999, { status: 1 }));
    dispatch(getAllProductCategory(null, 999999999, ""));
    dispatch(getAllProduct(null, 9999999999, ""));
    dispatch(getAllAccidentType(null, 999999999, ""));
  }, [dispatch]);

  const productCategories = useSelector(
    (state) => state?.productCategory?.productCategories?.data,
  );
  const products = useSelector((state) => state?.product?.products?.data);
  const customers = useSelector((state) => state?.customer?.customers?.data);
  const vehicles = useSelector((state) => state?.vehicle?.vehicles?.data);
  const insuranceCompanies = useSelector(
    (state) => state?.insuranceCompany?.insuranceCompanies?.data,
  );
  const accidentTypes = useSelector(
    (state) => state?.accidentTypes?.accidentTypes?.data,
  );
  const addEditLoading = useSelector((state) => state?.loading?.addEditLoading);
  const loading = useSelector((state) => state?.loading?.addEditLoading);

  const TypeOptions = [
    { label: "Private", value: "1" },
    { label: "Insurance", value: "2" },
    { label: "N/A", value: "3" },
  ];

  const save = () => {
    if (!estimateDate) {
      Toast.fire({
        icon: "error",
        title: "Estimate Date is Required!",
      });
    } else if (!repairTime) {
      Toast.fire({
        icon: "error",
        title: "Repair Time is Required!",
      });
    } else if (!milage) {
      Toast.fire({
        icon: "error",
        title: "Milage is Required!",
      });
    } else if (!accidentType) {
      Toast.fire({
        icon: "error",
        title: "Accident Side is Required!",
      });
    } else if (!typeId) {
      Toast.fire({
        icon: "error",
        title: "Type is Required!",
      });
    } else if (typeId == 2 && !contractorId) {
      Toast.fire({
        icon: "error",
        title: "Contractor is Required!",
      });
    } else if (typeId == 2 && !lumpSumAmount) {
      Toast.fire({
        icon: "error",
        title: "Lump Sum Amount is Required!",
      });
    } else if (!customerId) {
      Toast.fire({
        icon: "error",
        title: "Customer is Required!",
      });
    } else if (!contractorId) {
      Toast.fire({
        icon: "error",
        title: "Contractor is Required!",
      });
    } else if (!vehicleId) {
      Toast.fire({
        icon: "error",
        title: "Vehicle is Required!",
      });
    } else {
      let data = {
        estimate_date: estimateDate,
        amount: amount,
        repair_time: repairTime,
        milage: milage,
        accident_side: accidentType.name,
        accident_side_id: accidentType.id,
        lump_sum: lumpSum,
        lump_sum_amount: lumpSumAmount,
        cost_percentage: costPer,
        type_id: typeId,
        insurance_company_id: contractorId,
        customer_id: customerId,
        vehicle_id: vehicleId,
        detail: investigationDetails.detail,
        investigation_id: investigationId,
        vehicle_graph: vehicleGraph,
        fuel_level: fuelLevel,
        user_id: user_id,
      };
      dispatch(saveEstimate(data, navigate));
    }
    // window.location.href = ('/state');
  };

  const minusQuantity = async (index) => {
    let investigation = { ...investigationDetails };
    let quantity = parseInt(investigation.detail[index].quantity) - 1;
    if (quantity > 0) {
      investigation.detail[index].quantity = quantity.toString();
      if (investigation.detail[index].estimate_price) {
        investigation.detail[index].estimate_total_amount = Number(
          quantity * investigation.detail[index].estimate_price,
        ).toFixed(0);
        investigation.detail[index].total_amount = Number(
          quantity * investigation.detail[index].sale_price,
        ).toFixed(0);
      } else if (investigation.detail[index].estimate_price == null) {
        investigation.detail[index].total_amount = Number(
          quantity * investigation.detail[index].sale_price,
        ).toFixed(0);
      }
      setInvestigationDetails(investigation);
    }
  };

  const addQuantity = async (index) => {
    let investigation = { ...investigationDetails };
    let quantity = parseInt(investigation.detail[index].quantity) + 1;
    investigation.detail[index].quantity = quantity.toString();
    if (investigation.detail[index].estimate_price) {
      investigation.detail[index].estimate_total_amount = Number(
        quantity * investigation.detail[index].estimate_price,
      ).toFixed(0);
      investigation.detail[index].total_amount = Number(
        quantity * investigation.detail[index].sale_price,
      ).toFixed(0);
    } else if (investigation.detail[index].estimate_price == null) {
      investigation.detail[index].total_amount = Number(
        quantity * investigation.detail[index].sale_price,
      ).toFixed(0);
    }
    setInvestigationDetails(investigation);
  };

  const deleteItem = (e, item, index) => {
    let items = [...investigationDetails.detail];
    items.splice(index, 1);
    let investigation = { ...investigationDetails, detail: items };
    setInvestigationDetails(investigation);
  };

  const onClickItem = (selectedItem) => {
    let selectedItemNew = {
      product_id: parseInt(selectedItem.product_id),
      product_name: selectedItem.name,
      product_type: selectedItem.product_type,
      quantity: 1,
      sale_price: selectedItem.sale_price,
      total_amount: selectedItem.sale_price,
    };

    if (investigationDetails && Object.keys(investigationDetails).length > 0) {
      const existingItem = investigationDetails.detail.find(
        (item) => item.product_id === selectedItemNew.product_id,
      );
      if (existingItem) {
        Toast.fire({
          icon: "error",
          title: "Item Already Exists!",
        });
        setSelectedCategory("");
        setProductCategory("");
        setProduct("");
        setSelectedProduct("");
      } else {
        const updatedDetail = [...investigationDetails.detail, selectedItemNew];
        setInvestigationDetails({
          ...investigationDetails,
          detail: updatedDetail,
        });
        setSelectedCategory("");
        setProductCategory("");
        setProduct("");
        setSelectedProduct("");
      }
    } else {
      const newInvestigationDetails = {
        detail: [selectedItemNew],
      };
      setInvestigationDetails(newInvestigationDetails);
      setSelectedCategory("");
      setProductCategory("");
      setProduct("");
      setSelectedProduct("");
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState();

  const handleCreateAccidentType = (inputValue) => {
    setIsLoading(true);
    setTimeout(
      async () => {
        setIsLoading(false);
        let data = {
          name: inputValue,
        };
        await dispatch(saveAccidentType(data));
        dispatch(getAllAccidentType(null, 9999));
      },
      1000,
      [],
    );
    const newOption = {
      id: "new",
      name: inputValue,
    };
    setAccidentType(inputValue);
  };

  const handleChangeContractor = (e) => {
    setContractorId(e.insurance_company_id);
    setSelectedContractor({
      id: e.insurance_company_id,
      name: e.name,
    });
  };

  const handleAccidentType = (e) => {
    setAccidentType({
      id: e.id,
      name: e.name,
    });
  };

  const handleChangeType = (e) => {
    setTypeId(e.value);
    setSelectedType({
      value: e.value,
      label: e.label,
    });
  };

  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedProduct, setSelectedProduct] = useState();

  const handleChangeProductCategory = (e) => {
    getProducts(e.id);
    setProductCategory(e.id);
    setSelectedCategory({
      id: e.id,
      name: e.name,
    });
  };

  const handleChangeProduct = (e) => {
    setProduct(e);
    setSelectedProduct({
      id: e.id,
      name: e.name,
    });
  };

  const getProducts = (categoryId) => {
    dispatch(getProductByCategoryId(categoryId));
  };

  const [searchTerm, setSearchTerm] = useState("");

  const filteredProducts =
    products &&
    Object.keys(products).length > 0 &&
    products.filter((product) =>
      product.name.toLowerCase().includes(searchTerm.toLowerCase()),
    );

  const FuelOptions = [
    { label: "F", value: "F" },
    { label: "95%", value: "95%" },
    { label: "90%", value: "90%" },
    { label: "85%", value: "85%" },
    { label: "80%", value: "80%" },
    { label: "75%", value: "75%" },
    { label: "70%", value: "70%" },
    { label: "65%", value: "65%" },
    { label: "60%", value: "60%" },
    { label: "55%", value: "55%" },
    { label: "50%", value: "50%" },
    { label: "45%", value: "45%" },
    { label: "40%", value: "40%" },
    { label: "35%", value: "35%" },
    { label: "30%", value: "30%" },
    { label: "25%", value: "25%" },
    { label: "20%", value: "20%" },
    { label: "15%", value: "15%" },
    { label: "10%", value: "10%" },
    { label: "5%", value: "5%" },
    { label: "E", value: "E" },
  ];

  const handleChangFuel = (e) => {
    setFuelLevel(e.value);
  };

  const signatureRef = useRef(null);

  const clearCanvas = () => {
    signatureRef.current.clear();
    const base64Data = signatureRef.current.toDataURL();
    setVehicleGraph(base64Data);
  };

  const getVehicleGraph = () => {
    if (signatureRef.current) {
      signatureRef.current.getCanvas().style.width = "370px";
      signatureRef.current.getCanvas().style.height = "250px";
      const base64Data = signatureRef.current.toDataURL();
      setVehicleGraph(base64Data);
    } else {
      console.error("SignatureCanvas is not available yet.");
    }
  };

  const loadSignatureFromBase64 = (base64String) => {
    if (signatureRef.current && base64String) {
      signatureRef.current.clear();
      const img = new Image();
      img.src = base64String;
      img.onload = () => {
        const canvas = signatureRef.current && signatureRef.current.getCanvas();
        if (canvas) {
          const ctx = canvas.getContext("2d");
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          canvas.width = 370;
          canvas.height = 250;
          ctx.drawImage(img, 0, 0, 370, 250);
        }
      };
    }
  };

  return (
    <span>
      <Mobilemenu />
      <div className="content-body d-flex">
        <Webmenu />
        <div className="content">
          <Topbar />
          {addEditLoading ? (
            <ThreeDots
              height="80"
              width="80"
              radius="9"
              color="#2d3748"
              ariaLabel="three-dots-loading"
              wrapperStyle={{
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
              wrapperClassName=""
              visible={addEditLoading}
            />
          ) : (
            <span>
              <div className="d-flex align-items-center mt-8">
                <h2 className="intro-y px-5 fs-lg fw-medium me-auto">
                  Add Estimate
                </h2>
                <div className="d-flex justify-content-end mt-2">
                  <button
                    className="btn btn-primary me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#customer-modal"
                  >
                    Edit Customer
                  </button>
                  <button
                    className="btn btn-primary"
                    data-bs-toggle="modal"
                    data-bs-target="#vehicle-modal"
                  >
                    Edit Vehicle
                  </button>
                </div>
              </div>
              <div className="intro-y box ">
                <div className="px-5 mt-5 py-5">
                  <div className="grid columns-12 gap-4 gap-y-3 mt-3">
                    <div className="intro-y g-col-12 g-col-lg-8 g-col-md-8 g-col-sm-12">
                      <div className="grid columns-12 gap-4 gap-y-3 mt-3">
                        <div className="intro-y g-col-12 g-col-lg-2 g-col-md-4 g-col-sm-6 d-flex flex-column justify-items-center">
                          <label for="lump_sum" className="form-label">
                            Lump Sum :
                          </label>
                          <div className="mt-2">
                            <div className="form-check form-switch">
                              {" "}
                              <input
                                onChange={(e) => setLumpSum(e.target.checked)}
                                id="checkbox-switch-7"
                                checked={lumpSum == "1" ? true : false}
                                className="form-check-input"
                                type="checkbox"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="intro-y g-col-12 g-col-lg-5 g-col-md-4 g-col-sm-6">
                          <label for="date" className="form-label">
                            Date<span className="text-theme-6">*</span> :
                          </label>
                          <div className="input-group mx-auto ">
                            <div
                              id="input-group-email"
                              className="input-group-text form-control-rounded"
                            >
                              {" "}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                className="feather feather-calendar w-4 h-4"
                              >
                                <rect
                                  x="3"
                                  y="4"
                                  width="18"
                                  height="18"
                                  rx="2"
                                  ry="2"
                                ></rect>
                                <line x1="16" y1="2" x2="16" y2="6"></line>
                                <line x1="8" y1="2" x2="8" y2="6"></line>
                                <line x1="3" y1="10" x2="21" y2="10"></line>
                              </svg>{" "}
                            </div>{" "}
                            <input
                              type="date"
                              id="date"
                              value={estimateDate}
                              onChange={(e) => setEstimateDate(e.target.value)}
                              name="date"
                              className="datepicker form-control form-control-rounded"
                              data-single-mode="true"
                            />
                          </div>
                        </div>
                        <div className="intro-y g-col-12 g-col-lg-5 g-col-md-4 g-col-sm-6">
                          <label for="repair_time" className="form-label">
                            Repair Time<span className="text-theme-6">*</span> :
                          </label>
                          <input
                            id="repair_time"
                            value={repairTime}
                            onChange={(e) => setRepairTime(e.target.value)}
                            name="repair_time"
                            type="text"
                            className="form-control form-control-rounded"
                            placeholder="Enter Repair Time"
                          />
                        </div>
                        <div className="intro-y g-col-12 g-col-lg-4 g-col-md-4 g-col-sm-6">
                          <label for="milage" className="form-label">
                            Mileage<span className="text-theme-6">*</span> :
                          </label>
                          <input
                            id="milage"
                            name="milage"
                            value={milage}
                            onChange={(e) => setMilage(e.target.value)}
                            type="number"
                            className="form-control form-control-rounded"
                            placeholder="Enter Milage"
                          />
                        </div>
                        <div className="intro-y g-col-12 g-col-lg-4 g-col-md-4 g-col-sm-6">
                          <label for="accident_side" className="form-label">
                            Accident Side<span className="text-theme-6">*</span>{" "}
                            :
                          </label>
                          <CreatableSelect
                            formatCreateLabel={() => "Create New.."}
                            getNewOptionData={(inputValue, optionLabel) => ({
                              id: "new",
                              name: "Create " + '"' + inputValue + '"',
                            })}
                            isDisabled={isLoading}
                            isLoading={isLoading}
                            onCreateOption={(e) => handleCreateAccidentType(e)}
                            value={accidentType}
                            onChange={(e) => handleAccidentType(e)}
                            getOptionLabel={(option) => `${option.name}`}
                            getOptionValue={(option) => `${option.id}`}
                            options={
                              accidentTypes && accidentTypes.length > 0
                                ? accidentTypes
                                : []
                            }
                            styles={roundedStyleSelect}
                            placeholder="Select Accident Side"
                          />
                        </div>

                        <div className="intro-y g-col-12 g-col-lg-4 g-col-md-4 g-col-sm-6 ">
                          <label for="type" className="form-label">
                            Type<span className="text-theme-6">*</span> :
                          </label>
                          <Select
                            className="z-10"
                            onChange={(e) => handleChangeType(e)}
                            value={selectedType}
                            options={TypeOptions}
                            styles={roundedStyleSelect}
                            placeholder="Select Type"
                          />
                        </div>
                        {typeId == 2 ? (
                          <div className="intro-y g-col-12 g-col-lg-4 g-col-md-4 g-col-sm-6 ">
                            <label htmlFor="contractor" className="form-label">
                              Contractor<span className="text-theme-6">*</span>{" "}
                              :
                            </label>
                            <Select
                              className="z-10"
                              value={selectedContractor}
                              onChange={(e) => handleChangeContractor(e)}
                              getOptionLabel={(option) => `${option.name}`}
                              getOptionValue={(option) =>
                                `${option.insurance_company_id}`
                              }
                              options={
                                insuranceCompanies &&
                                insuranceCompanies.length > 0
                                  ? insuranceCompanies
                                  : []
                              }
                              styles={roundedStyleSelect}
                              placeholder="Select Contractor"
                            />
                          </div>
                        ) : (
                          <div className="intro-y g-col-12 g-col-lg-4 g-col-md-4 g-col-sm-6 ">
                            <label htmlFor="contractor" className="form-label">
                              Contractor :
                            </label>
                            <Select
                              className="z-10"
                              value={selectedContractor}
                              onChange={(e) => handleChangeContractor(e)}
                              getOptionLabel={(option) => `${option.name}`}
                              getOptionValue={(option) => `${option.id}`}
                              options={
                                insuranceCompanies &&
                                insuranceCompanies.length > 0
                                  ? insuranceCompanies
                                  : []
                              }
                              styles={roundedStyleSelect}
                              placeholder="Select Contractor"
                            />
                          </div>
                        )}
                        <div className="intro-y g-col-12 g-col-lg-4 g-col-md-4 g-col-sm-6">
                          <label for="customer" className="form-label">
                            Customer<span className="text-theme-6">*</span> :
                          </label>
                          <div className="d-flex flex-column">
                            {investigationDetails?.customer_id ? (
                              <Select
                                isDisabled
                                value={selectedCustomer}
                                styles={roundedStyleSelect}
                                placeholder="Select Customer"
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) =>
                                  `${option.customer_id}`
                                }
                                options={
                                  customers && customers.length > 0
                                    ? customers
                                    : []
                                }
                              />
                            ) : (
                              <Select
                                value={selectedCustomer}
                                onChange={(e) => setCustomerId(e.customer_id)}
                                getOptionLabel={(option) => `${option.name}`}
                                getOptionValue={(option) =>
                                  `${option.customer_id}`
                                }
                                options={
                                  customers && customers.length > 0
                                    ? customers
                                    : []
                                }
                                styles={roundedStyleSelect}
                                placeholder="Select Customer"
                              />
                            )}
                          </div>
                        </div>
                        <div className="intro-y g-col-12 g-col-lg-4 g-col-md-4 g-col-sm-6">
                          <label for="vehicle" className="form-label">
                            Vehicle<span className="text-theme-6">*</span> :
                          </label>
                          <div className="d-flex flex-column">
                            {investigationDetails?.vehicle_id ? (
                              <Select
                                isDisabled
                                value={selectedVehicle}
                                styles={roundedStyleSelect}
                                placeholder="Select Vehicle"
                                getOptionLabel={(option) =>
                                  `${option.plate_number}`
                                }
                                getOptionValue={(option) =>
                                  `${option.vehicle_id}`
                                }
                                options={
                                  vehicles && vehicles.length > 0
                                    ? vehicles
                                    : []
                                }
                              />
                            ) : (
                              <Select
                                value={selectedVehicle}
                                onChange={(e) => setVehicleId(e.vehicle_id)}
                                getOptionLabel={(option) =>
                                  `${option.plate_number}`
                                }
                                getOptionValue={(option) =>
                                  `${option.vehicle_id}`
                                }
                                options={
                                  vehicles && vehicles.length > 0
                                    ? vehicles
                                    : []
                                }
                                styles={roundedStyleSelect}
                                placeholder="Select Vehicle"
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="intro-y g-col-12 g-col-lg-4 g-col-md-4 g-col-sm-12">
                      <div className="d-flex align-items-center justify-content-between">
                        <label for="signature" className="form-label">
                          Vehicle Graph <span className="text-theme-6">*</span>{" "}
                          :
                        </label>
                        <button
                          className="btn btn-outline-secondary mb-2"
                          onClick={clearCanvas}
                        >
                          Clear
                        </button>
                      </div>
                      <div
                        className="border border-gray-300 rounded-2 canvas-bg"
                        style={{ width: 370, height: 250 }}
                      >
                        <SignatureCanvas
                          penColor="red"
                          onEnd={getVehicleGraph}
                          ref={(ref) => (signatureRef.current = ref)}
                          onKeyPress={clearCanvas}
                          canvasProps={{
                            width: 370,
                            height: 250,
                            className: "signatureCanvas",
                          }}
                        />
                      </div>
                      <label for="crud-form-1" className="form-label mt-3">
                        Fuel <span className="text-theme-6">*</span> :
                      </label>
                      <Select
                        styles={styleSelect}
                        className="z-50"
                        value={{ label: fuelLevel, value: fuelLevel }}
                        options={FuelOptions}
                        id="repalcedVehicleFuelId"
                        name="replacedVehicleFuelOut"
                        onChange={(e) => handleChangFuel(e)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="intro-y box g-col-12 border border-gray-600 mt-4 p-5">
                <div className="d-flex justify-content-between align-items-center mb-5">
                  <h2 className="intro-y fs-lg fw-medium">
                    Products :
                    <button
                      className="btn btn-primary p-1 ms-1"
                      data-bs-toggle="modal"
                      data-bs-target="#add-product-modal"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="feather feather-plus w-4 h-4"
                      >
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                      </svg>
                    </button>
                  </h2>
                  <div className="intro-y d-flex align-items-center">
                    <div className="me-3">
                      <label for="costPer" className="form-label">
                        Cost (%) :
                      </label>
                      <input
                        id="costPer"
                        name="costPer"
                        value={costPer}
                        max={100}
                        onChange={(e) => setCostPer(e.target.value)}
                        type="number"
                        className="form-control form-control-rounded"
                        placeholder="Enter Cost Percentage"
                      />
                    </div>
                    <div>
                      <label for="lumpSumAmount" className="form-label">
                        Lum Sum Amount {selectedType?.value == 2 && <span className="text-theme-6">*</span>} :
                      </label>
                      <input
                        id="lumpSumAmount"
                        name="lumpSumAmount"
                        value={lumpSumAmount}
                        onChange={(e) => setLumpSumAmount(e.target.value)}
                        type="number"
                        className="form-control form-control-rounded"
                        placeholder="Enter Lump Sum Amount"
                        required={selectedType?.value == 2}
                      />
                    </div>
                  </div>
                </div>
                <div className="pos intro-y grid columns-12 gap-5">
                  <div className="intro-y g-col-12 g-col-lg-12">
                    <div className="grid columns-12 align-items-center">
                      <div className="g-col-12 g-col-sm-12 border border-gray-300 rounded-2 me-3 p-3">
                        <div className="position-relative text-gray-700 dark-text-gray-300">
                          <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="form-control py-3 px-4 box border-white dark-border-dark-3 w-full placeholder-theme-13"
                            placeholder="Search item..."
                          />
                          <i
                            className="w-4 h-4 position-absolute my-auto top-0 bottom-0 me-3 end-0"
                            data-feather="search"
                          ></i>
                        </div>
                      </div>
                    </div>
                    {searchTerm && (
                      <div className="grid columns-12 border border-gray-300 rounded-2 mt-3 p-3">
                        <div className="g-col-12 g-col-sm-6">
                          <label
                            for="crud-form-1"
                            className="form-label fw-medium"
                          >
                            Spare Parts :
                          </label>
                          <div className="p-3 border border-gray-300 rounded-2 h-64 overflow-y-auto">
                            {searchTerm &&
                              filteredProducts &&
                              filteredProducts.map((product) =>
                                product?.product_type === "goods" ? (
                                  <div
                                    className="m-2 float-start p-1"
                                    key={product.product_id}
                                  >
                                    <button
                                      className="btn btn-secondary-outline w-fit-content border border-gray-500"
                                      type="button"
                                      onClick={() => onClickItem(product)}
                                    >
                                      {product?.name}
                                    </button>
                                  </div>
                                ) : null,
                              )}
                          </div>
                        </div>
                        <div className="g-col-12 g-col-sm-6">
                          <label
                            for="crud-form-1"
                            className="form-label fw-medium"
                          >
                            Repairs :
                          </label>
                          <div className="p-3 border border-gray-300 rounded-2 h-64 overflow-y-auto">
                            {searchTerm &&
                              filteredProducts &&
                              filteredProducts.map((product) =>
                                product?.product_type === "service" ? (
                                  <div
                                    className="m-2 float-start p-1"
                                    key={product.product_id}
                                  >
                                    <button
                                      className="btn btn-secondary-outline w-fit-content border border-gray-500"
                                      type="button"
                                      onClick={() => onClickItem(product)}
                                    >
                                      {product?.name}
                                    </button>
                                  </div>
                                ) : null,
                              )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="overflow-auto">
                  <table class="table table-striped border-top border-gray-600 mt-4 ">
                    <thead>
                      <tr>
                        <th className="text-nowrap">S. No</th>
                        <th className="text-nowrap">Parts / Services</th>
                        <th className="text-nowrap">Type</th>
                        <th className="text-nowrap">Price (AED)</th>
                        <th className="text-nowrap">Estimated Price (AED)</th>
                        <th className="text-nowrap ps-10">Quantity</th>
                        <th className="text-nowrap">Total (AED)</th>
                        <th className="text-nowrap">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {investigationDetails &&
                        Object.keys(investigationDetails).length > 0 &&
                        investigationDetails.detail.map((detail, index) => {
                          const handleEstimatedPriceChange = (e) => {
                            const newEstimatedPrice = parseFloat(
                              e.target.value,
                            );
                            if (!isNaN(newEstimatedPrice)) {
                              const productId =
                                e.target.getAttribute("data-productid");

                              const updatedDetails =
                                investigationDetails.detail.map((d) => {
                                  if (d.product_id == productId) {
                                    return {
                                      ...d,
                                      estimate_total_amount:
                                        newEstimatedPrice * d.quantity,
                                      estimate_price: newEstimatedPrice,
                                    };
                                  }
                                  return d;
                                });
                              setInvestigationDetails({
                                ...investigationDetails,
                                detail: updatedDetails,
                              });
                            } else {
                              const productId =
                                e.target.getAttribute("data-productid");

                              const updatedDetails =
                                investigationDetails.detail.map((d) => {
                                  if (d.product_id == productId) {
                                    return {
                                      ...d,
                                      estimate_total_amount: null,
                                      estimate_price: null,
                                      total_amount: d.sale_price * d.quantity,
                                    };
                                  }
                                  return d;
                                });

                              setInvestigationDetails({
                                ...investigationDetails,
                                detail: updatedDetails,
                              });
                            }
                          };

                          return (
                            <tr key={index}>
                              <td className="text-nowrap">{index + 1}</td>
                              <td className="text-nowrap">
                                {detail?.product_name}
                              </td>
                              <td className="text-capitalize">
                                {detail?.product_type === "spare_parts"
                                  ? "Spare Parts"
                                  : detail?.product_type}
                              </td>
                              <td className="text-nowrap">
                                {detail?.sale_price ?? 0}
                              </td>
                              <td className="text-nowrap">
                                <input
                                  id={`estimatedPrice-${index}`}
                                  name="estimatedPrice"
                                  onChange={handleEstimatedPriceChange}
                                  type="number"
                                  className="form-control w-40"
                                  placeholder="Estimated Price.."
                                  value={detail?.estimate_price ?? ""}
                                  data-productid={detail.product_id}
                                />
                              </td>
                              <td className="text-nowrap">
                                <div class="input-group" style={{ width: 120 }}>
                                  <div
                                    class="input-group-text cursor-pointer fw-medium"
                                    onClick={() => minusQuantity(index)}
                                  >
                                    -
                                  </div>
                                  <input
                                    type="text"
                                    class="form-control text-center"
                                    value={detail?.quantity}
                                    placeholder="Quantity"
                                  />
                                  <div
                                    onClick={() => addQuantity(index)}
                                    class="input-group-text cursor-pointer fw-medium"
                                  >
                                    +
                                  </div>
                                </div>
                              </td>
                              <td className="text-nowrap">
                                {detail.estimate_total_amount == null
                                  ? detail?.total_amount
                                  : Number(
                                      parseInt(detail?.estimate_total_amount),
                                    ).toFixed(1)}
                              </td>
                              <td className="text-nowrap">
                                <button
                                  className="d-flex align-items-center bg-transparent text-theme-6"
                                  onClick={(e) => deleteItem(e, detail, index)}
                                >
                                  {" "}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    className="feather feather-trash-2 me-1 w-6 h-6"
                                  >
                                    <polyline points="3 6 5 6 21 6"></polyline>
                                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                    <line
                                      x1="10"
                                      y1="11"
                                      x2="10"
                                      y2="17"
                                    ></line>
                                    <line
                                      x1="14"
                                      y1="11"
                                      x2="14"
                                      y2="17"
                                    ></line>
                                  </svg>{" "}
                                  Delete{" "}
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                <button
                  onClick={() => navigate("/estimates")}
                  className="btn btn-outline-secondary bg-white w-24 ms-2"
                >
                  Cancel
                </button>
                <button
                  onClick={save}
                  type="button"
                  disabled={loading ? true : false}
                  className="btn btn-primary w-24 ms-2"
                >
                  Save
                </button>
              </div>

              <AddProduct />
              <EditVehicleModal vehicleId={investigationDetails?.vehicle_id} />
              <EditCustomerModal
                customerId={investigationDetails?.customer_id}
              />
            </span>
          )}
        </div>
      </div>
    </span>
  );
}

export default AddEstimate;
